import { makeAutoObservable } from "mobx";
import {
    deleteServiceShiftWork,
    getServiceShiftWorkById,
    saveOrUpdate,
    pagingServiceShiftWork,
    getAllServiceShiftWork
} from 'app/services/ServiceShiftWorkService';

import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { ServiceShiftWork } from "app/common/Model/ServiceShiftWork";
import { checkSearchObject } from "app/common/LocalFunction";

export default class ServiceShiftWorkStore {
    listAllServiceShiftWork = [];
    searchServiceShiftWork = new SearchObject();
    pageServiceShiftWork = null;
    selectedServiceShiftWork = null;
    openFormCreateOrEdit = false;
    openConfirmDelete = false;
    recentlyUpdated = false;

    constructor() {
        makeAutoObservable(this);
    }

    getAllServiceShiftWork = async () => {
        if (this.listAllServiceShiftWork?.length === 0 || this.recentlyUpdated) {
            getAllServiceShiftWork()
                .then(({ data }) => {
                    this.listAllServiceShiftWork = data;
                    this.recentlyUpdated = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi")
                })
        }
    }

    pagingServiceShiftWork = async () => {
        return await pagingServiceShiftWork(this.searchServiceShiftWork)
            .then(({ data }) => {
                this.pageServiceShiftWork = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi")
            })
    }

    handleChangeFormSearch = (searchServiceShiftWork) => {
        this.searchServiceShiftWork = checkSearchObject(this.searchServiceShiftWork, searchServiceShiftWork);
        this.pagingServiceShiftWork();
    }

    handleOpenFormCreateOrEdit = (serviceShiftWorkId) => {
        if (Boolean(serviceShiftWorkId)) {
            getServiceShiftWorkById(serviceShiftWorkId).then(({ data }) => {
                this.selectedServiceShiftWork = data;
                this.openFormCreateOrEdit = true;
            })
        } else {
            this.selectedServiceShiftWork = new ServiceShiftWork();
            this.openFormCreateOrEdit = true;
        }
    }

    saveOrUpdateServiceShiftWork = (serviceShiftWork, { setSubmitting }) => {
        saveOrUpdate(serviceShiftWork)
            .then(() => {
                this.selectedServiceShiftWork = null;
                toast.success("Lưu dữ liệu thành công!");
                this.handleClosePopup();
                this.pagingServiceShiftWork();
                this.recentlyUpdated = true;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lưu dữ liệu có lỗi");
            })
            .finally(() => setSubmitting(false))
    }

    handleDelete = (serviceShiftWork) => {
        this.selectedServiceShiftWork = { id: serviceShiftWork?.id };
        this.openConfirmDelete = true;
    }

    handleConfirmDelete = async () => {
        return await deleteServiceShiftWork(this.selectedServiceShiftWork?.id)
            .then(() => {
                if (this.searchServiceShiftWork?.pageIndex > 1 && this.pageServiceShiftWork?.content?.length === 1) {
                    this.searchServiceShiftWork.pageIndex -= 1;
                }
                toast.success("Xóa bản ghi thành công!");
                this.handleClosePopup();
                this.pagingServiceShiftWork();
                this.recentlyUpdated = true;
            })
            .catch(err => {
                console.error(err);
                toast.error("Xóa bản ghi có lỗi");
            })
    }

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    resetStore = () => {
        this.searchServiceShiftWork = new SearchObject();
        this.pageServiceShiftWork = null;
        this.selectedServiceShiftWork = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDelete = false;
    }

    //for choosing serviceShiftWork popup in ChooseServiceShiftWorkPopup.jsx 
    listServiceShiftWork = [];
    serviceShiftWorkIdSet = null;

    isValidServiceShiftWork = serviceShiftWork => {
        if (serviceShiftWork && serviceShiftWork?.id) return true;
        console.error("Invalid manipulated element");
        return false;
    }

    addServiceShiftWork = serviceShiftWork => {
        if (!this.isValidServiceShiftWork(serviceShiftWork)) return;
        this.listServiceShiftWork.push(serviceShiftWork);
        this.serviceShiftWorkIdSet.add(serviceShiftWork?.id);
    }

    initializeListServiceShiftWork = serviceShiftWorks => {
        this.serviceShiftWorkIdSet = new Set();
        this.listServiceShiftWork = [];
        if (serviceShiftWorks && serviceShiftWorks?.length > 0) {
            for (let i = 0; i < serviceShiftWorks.length; i++) {
                this.addServiceShiftWork(serviceShiftWorks[i]);
            }
        }
    }

    removeServiceShiftWork = serviceShiftWork => {
        if (!this.isValidServiceShiftWork(serviceShiftWork)) return;
        if (this.serviceShiftWorkIdSet.has(serviceShiftWork?.id)) {
            this.serviceShiftWorkIdSet.delete(serviceShiftWork?.id);
        }
        else {
            console.error("Element is not exist");
        }
    }

    isExist = serviceShiftWork => {
        if (!this.isValidServiceShiftWork(serviceShiftWork)) return;
        return this.serviceShiftWorkIdSet.has(serviceShiftWork?.id);
    }

    getServiceShiftWorkIdSet = () => {
        return this.serviceShiftWorkIdSet;
    }

    getListServiceShiftWork = () => {
        const bufferIdSet = new Set();
        const data = [];
        if (this.listServiceShiftWork && this.listServiceShiftWork?.length > 0) {
            for (let i = 0; i < this.listServiceShiftWork.length; i++) {
                const serviceShiftWork = this.listServiceShiftWork[i];
                if (this.isExist(serviceShiftWork) && !bufferIdSet.has(serviceShiftWork?.id)) {
                    data.push(serviceShiftWork);
                    bufferIdSet.add(serviceShiftWork?.id);
                }
            }
        }
        this.listServiceShiftWork = data;
        return data;
    }
    //end
}
